module.exports = __webpack_public_path__ + "static/sm-3-8da5c1f8218e89257c93222d6e301752.png";